import { render, staticRenderFns } from "./Journalism.vue?vue&type=template&id=7ec5305a&scoped=true&"
import script from "./Journalism.vue?vue&type=script&lang=js&"
export * from "./Journalism.vue?vue&type=script&lang=js&"
import style0 from "./Journalism.vue?vue&type=style&index=0&id=7ec5305a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec5305a",
  null
  
)

export default component.exports